import React from "react";

export default function Rounded({ children, small = false }) {
  const className = small
    ? "bg-[#0862C1] text-default shadow-md shadow-black w-[140px] text-center py-2 rounded-full"
    : "bg-[#0862C1] text-default shadow-md shadow-black w-[280px] text-center py-2 rounded-full";
  return <div className={className}>{children}</div>;
}
